import script from "./PromoTotalPrices.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromoTotalPrices.vue?vue&type=script&lang=ts&setup=true"

import "./PromoTotalPrices.vue?vue&type=style&index=0&id=79f4ead5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79f4ead5"]])

export default __exports__